import React, { Ref } from 'react';

import { SelectProps } from '../Select';
import SingleSelector from './SingleSelector';
import MultipleSelector from './MultipleSelector';

import { SelectOptionType } from '../types';

export interface SelectorProps<T extends SelectOptionType = SelectOptionType>
  extends Omit<SelectProps<T>, 'filterOption' | 'onChange'> {
  isOpen: boolean;
  inputRef: Ref<HTMLDivElement>;
  selectedValue: string | string[];
  onToggleOpen: (open?: boolean) => void;
  onClearSelect: (value: string) => void;
  onClearSelectedValue: () => void;
}

function Selector<T extends SelectOptionType>(props: SelectorProps<T>) {
  const { selectedValue, multiple = false } = props;

  const sharedProps = {};

  const selectNode = multiple ? (
    <MultipleSelector {...props} {...sharedProps} selectedValue={selectedValue as string[]} />
  ) : (
    <SingleSelector {...props} {...sharedProps} selectedValue={selectedValue as string} />
  );

  return selectNode;
}

export default Selector;
